import { library } from "@fortawesome/fontawesome-svg-core";

import { faHyphen } from "@fortawesome/pro-thin-svg-icons";

export function initThinIcons() {
  library.add(faHyphen);
}
